import React, { Component } from 'react';
/* Components */
import LoadingModal from '../common/loadingModal';
import TodayReportsTable from './todayReportsTable';

class ModalTodayReport extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div
        data-close="ok"
        onClick={this.props.handleClose}
        className={this.props.showModal ? `container-modal` : `container-modal hide`}
      >
        <section className="module-title modal-title special">
          <h2>{"Solicitudes"}</h2>
          <a>
            <i data-close="ok" onClick={this.props.handleClose} className="fas fa-times-circle" />
          </a>
        </section>
        <div className={`box-modal`}>
          <section id="modal-today-report" className="base-form">
            {
              this.props.data 
              && this.props.data.flowRequestsByFilterTagAndTimeStats
              && this.props.data.flowRequestsByFilterTagAndTimeStats.map((item, i)=>(
                <div key={i} className="modal-today-report-row">
                  <TodayReportsTable
                    data={item}
                    usedDirection={"Up"}
                    usedDirectionLabel={"Subida"}
                    language={this.props.language}
                  />
                  <TodayReportsTable
                    data={item}
                    usedDirection={"Down"}
                    usedDirectionLabel={"Bajada"}
                    language={this.props.language}
                  />
                </div>                
              ))
            }
          </section>
        </div>
        <div className={'box-form islabel top center modal-button-box special'}>
        </div>
      </div>
    );
  }
}

export default ModalTodayReport;



// WEBPACK FOOTER //
// ./source/client/components/flow_admin_detail/modalTodayReport.jsx